import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/retail_pay_drivers`, {params: {...filters}})
  },
}